<template>
  <div class="flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-primary-blue-10 w-max cursor-default">
    <MetaPlatformIcon />
    <BaseText type="label" size="xs" class="text-primary-blue-300">
      Meta Only
    </BaseText>
  </div>
</template>

<script>
import MetaPlatformIcon from '../../globals/Icons/FilterIcons/Platforms/MetaPlatformIcon.vue'

export default {
  name: 'MetaOnlyLabel',
  components: {
    MetaPlatformIcon
  }
}
</script>